import React from 'react';
import logo from './logo.svg';
import styled from 'styled-components';
import Board from './Board';

export const App = () => {
	return (
		<Board/>
	)
}
